(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel-arrows"] && !Shopify.designMode) return;
  try {
    class ScrollCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-carousel-viewport]');

      if (!this.viewport) return;

      this.previous = this.querySelector('[data-carousel-previous]');
      this.next = this.querySelector('[data-carousel-next]');

      this.update = this.update.bind(this);

      this.viewport.addEventListener('scroll', this.update, { passive: true });

      if (this.previous) {
        this.previous.addEventListener('click', () => this.step(-1));
      }

      if (this.next) {
        this.next.addEventListener('click', () => this.step(1));
      }

      if (typeof ResizeObserver === 'function') {
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.viewport);
      }

      this.update();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.viewport) this.viewport.removeEventListener('scroll', this.update);
    }

    step(direction) {
      const track = this.viewport.querySelector('[data-carousel-track]');
      const item = track ? track.firstElementChild : null;

      let amount = this.viewport.clientWidth;

      if (item) {
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const width = item.getBoundingClientRect().width;

        if (width) amount = width + gap;
      }

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.viewport.scrollBy({
        left: amount * direction,
        behavior: reduced ? 'auto' : 'smooth',
      });
    }

    update() {
      const maximum = this.viewport.scrollWidth - this.viewport.clientWidth;
      const position = this.viewport.scrollLeft;

      this.classList.toggle('carousel--scrollable', maximum > 1);

      if (this.previous) this.previous.disabled = position <= 1;
      if (this.next) this.next.disabled = position >= maximum - 1;
    }
  }

  if (!customElements.get('scroll-carousel')) {
    customElements.define('scroll-carousel', ScrollCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marquee"] && !Shopify.designMode) return;
  try {
    class MarqueeRow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-marquee-track]');
      this.group = this.track ? this.track.firstElementChild : null;

      if (!this.group) return;

      this.measure();

      if (typeof ResizeObserver === 'function') {
        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    measure() {
      while (this.track.children.length > 1) {
        this.track.removeChild(this.track.lastElementChild);
      }

      const groupWidth = this.group.getBoundingClientRect().width;

      if (!groupWidth) return;

      const copies = Math.ceil(this.offsetWidth / groupWidth) + 1;

      for (let index = 0; index < copies; index += 1) {
        const clone = this.group.cloneNode(true);

        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => {
          node.removeAttribute('data-shopify-editor-block');
        });
        clone.querySelectorAll('a, button, input').forEach((node) => {
          node.setAttribute('tabindex', '-1');
        });

        this.track.appendChild(clone);
      }

      const speed = parseFloat(this.dataset.speed) || 60;

      this.style.setProperty('--marquee-distance', groupWidth + 'px');
      this.style.setProperty('--marquee-duration', groupWidth / speed + 's');
      this.classList.add('marquee--ready');
    }
  }

  if (!customElements.get('marquee-row')) {
    customElements.define('marquee-row', MarqueeRow);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Delegated rather than per-card, because a grid can hold dozens of cards.
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const cardOf = (node) => (node instanceof Element ? node.closest('.product-card') : null);

    const play = (event) => {
      if (reduced.matches) return;

      const card = cardOf(event.target);
      const video = card && card.querySelector('.product-card__video');

      if (video && video.paused) video.play().catch(() => {});
    };

    const stop = (event) => {
      const card = cardOf(event.target);

      if (!card) return;

      // pointerout and focusout also fire when moving between elements inside
      // the same card, which would restart the clip on every internal hop.
      if (event.relatedTarget instanceof Node && card.contains(event.relatedTarget)) return;

      const video = card.querySelector('.product-card__video');

      if (!video || video.paused) return;

      video.pause();
      video.currentTime = 0;
    };

    document.addEventListener('pointerover', play);
    document.addEventListener('focusin', play);
    document.addEventListener('pointerout', stop);
    document.addEventListener('focusout', stop);
  })();
  } catch(e) { console.error(e); }
})();

})();
